<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {
    baseList,
  },
  data() {
    return {
      table: {
        mname: "payroll",
        key: "id",
        url: {
          list: "/admin/system/payroll/list",
          del: "/admin/system/payroll/del",
        },
        output: false,
      },
      actions: [],
      /* filters: [
        {
          label: "员工名称",
          KeyEnter: this.search,
          name: "userId",
          value: "",
          type: "select",
          dropList: [],
        },
      ], */
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "客户经理",
          minWidth: 100,
          align: "center",
          key: "userName",
        },
        {
          title: "佣金",
          minWidth: 240,
          align: "center",
          key: "payMoney",
          render: (h, params) => {
            const row = params.row;
            const budget = row.payMoney;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
        {
          title: "备注",
          minWidth: 90,
          align: "center",
          key: "remark",
        },
        {
          title: "操作",
          align: "center",
          width: 200,
          key: "handle",
          fixed: "right",
          handle: ["edit", "delete"],
        },
      ],
      query: {
        customerId: null,
        type: null,
        monthTime: null,
      },
      customerName: "",
    };
  },
  created() {
    let query = this.$route.query;
    if (query.type) {
      this.query.type = query.type;
      this.query.customerId = query.customerId;
      this.query.monthTime = query.monthTime;
      this.onChangecustomer(query.customerId);
    }
    if (query.type == 1) {
      this.tableCols[1].title = "工程师";
      this.tableCols[2].title = "工资";
    }
    if (query.type == 2) {
      let obj = {
        title: "佣金点",
        minWidth: 240,
        align: "center",
        key: "payProportion",
        render: (h, params) => {
          const row = params.row.payProportion ? params.row.payProportion : 0;
          return <span>{row}%</span>;
        },
      };
      let obj2 = {
        title: "项目名称",
        minWidth: 180,
        align: "center",
        key: "projectName",
      };
      this.tableCols.splice(2, 0, obj);
      this.tableCols.splice(3, 0, obj2);
    }
  },
  methods: {
    async onChangecustomer(id) {
      let q = {
        customerId: id,
      };
      let res = await $utils.api.load("/admin/system/maiUser/insCustomerList", q);
      if (res && res.data) {
        let ll = res.data;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.userId;
          xx.name = element.nickName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.filters.length; index++) {
          const element = this.filters[index];
          if (element && element.name == "userId") {
            this.filters[index]["dropList"] = dropList;
          }
        }
      }
    },
    handleEdit(row) {
      let kv = row.id;
      if (this.query.type == 2) {
        $utils.url.push({
          name: "add_Commissions",
          query: {
            action: "edit",
            kv: kv,
            type: this.query.type,
            // customerId: this.query.customerId,
          },
        });
      } else if (this.query.type == 1) {
        $utils.url.push({
          name: "add_Cost",
          query: {
            action: "edit",
            kv: kv,
            type: this.query.type,
            customerId: this.query.customerId,
          },
        });
      }
    },
  },
};
</script>
